export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-2.6adefd09.png";